import '../styles/PageGlobal.css';
import './DevisNewPage.css';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReferenceButton from '../components/ReferenceButton';
import { DevisService } from '../services/DevisService.js';

import ProduitsPicker from '../components/ProduitsPicker';
import DevisAdresseLivPicker from '../components/DevisAdresseLivPicker';
import DevisClientPicker from '../components/DevisClientPicker';

export default function DevisNewPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showProduitPicker, setShowProduitPicker] = useState(false);
  const [showAdresseLivPicker, setShowAdresseLivPicker] = useState(false);
  const [showClientPicker, setShowClientPicker] = useState(false);

  const [clientId, setClientId] = useState(null);
  const [clientNom, setClientNom] = useState('');
  const [adresseLivId, setAdresseLivId] = useState(null);
  const [lines, setLines] = useState([]);

  const handleClientSelect = (client) => {
    setClientId(client.id);
    setClientNom(client.nom || client.societe1 || 'Client sélectionné');
    setShowClientPicker(false);
  };

  const handleAdresseSelect = (adresse) => {
    setAdresseLivId(adresse.id);
    setShowAdresseLivPicker(false);
  };

  const handleProductSelect = (products) => {
    const newLines = products.map((p, index) => ({
      id: Date.now() + index,
      //NOMS EXACTS ATTENDUS PAR DevisLineDTO.java
      productId: p.id,
      reference: p.refInterne || p.reference || `REF-${p.id}`,
      refFabricant: p.refFabricant || p.ean || '',
      quantity: 1
    }));
    setLines(prev => [...prev, ...newLines]);
    setShowProduitPicker(false);
  };

  const handleDeleteLine = (id) => {
    setLines(lines.filter(l => l.id !== id));
  };

  const handleChangeLine = (id, field, value) => {
    setLines(lines.map(l => l.id === id ? { ...l, [field]: value } : l));
  };

  const handlePublish = async () => {
    if (!clientId) {
      alert("Veuillez sélectionner un client avant de publier.");
      return;
    }
    if (lines.length === 0) {
      alert("Veuillez ajouter au moins un produit au devis.");
      return;
    }

    const service = new DevisService();
    setLoading(true);
    try {
     
      const payload = {
        clientId: clientId,
        adresseLivraisonId: adresseLivId,
        status: "DRAFT",
        lines: lines.map(l => ({
          productId: l.productId,
          reference: l.reference,
          refFabricant: l.refFabricant,
          quantity: l.quantity
        }))
      };

    

     await service.createDevis(payload);
    alert("Devis créé avec succès !");
    navigate("/devis_list");
    } catch (err) {
      console.error("Erreur création :", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="containerMain devis-new-container">
      <h1 className="devis-title">Créer un nouveau devis</h1>
      {error && <div className="devis-status devis-status-error">{error}</div>}

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <ReferenceButton onClick={() => setShowClientPicker(true)}>
          {clientNom ? `Client: ${clientNom}` : '+ Sélectionner un client'}
        </ReferenceButton>
        <ReferenceButton onClick={() => setShowAdresseLivPicker(true)}>
          {adresseLivId ? `Adresse ID: ${adresseLivId}` : '+ Adresse de livraison'}
        </ReferenceButton>
        <ReferenceButton onClick={() => setShowProduitPicker(true)}>
          + Ajouter des produits
        </ReferenceButton>
      </div>

      {showClientPicker && <DevisClientPicker onClose={() => setShowClientPicker(false)} onSelect={handleClientSelect} />}
      {showAdresseLivPicker && <DevisAdresseLivPicker clientId={clientId} onClose={() => setShowAdresseLivPicker(false)} onSelect={handleAdresseSelect} />}
      {showProduitPicker && <ProduitsPicker onClose={() => setShowProduitPicker(false)} onSelect={handleProductSelect} />}

      <div className="devis-table-wrapper">
        <table className="devis-table">
          <thead>
            <tr>
              <th>Référence</th>
              <th>Ref. Fabricant</th>
              <th>Product ID</th>
              <th>Quantité</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {lines.length === 0 ? (
              <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Aucun produit ajouté</td></tr>
            ) : (
              lines.map((line) => (
                <tr key={line.id}>
                  <td><input type="text" value={line.reference} onChange={(e) => handleChangeLine(line.id, 'reference', e.target.value)} style={{ width: '100px', padding: '4px' }} /></td>
                  <td><input type="text" value={line.refFabricant} onChange={(e) => handleChangeLine(line.id, 'refFabricant', e.target.value)} style={{ width: '120px', padding: '4px' }} /></td>
                  <td><input type="number" value={line.productId} onChange={(e) => handleChangeLine(line.id, 'productId', Number(e.target.value))} style={{ width: '80px', padding: '4px' }} /></td>
                  <td><input type="number" min="1" value={line.quantity} onChange={(e) => handleChangeLine(line.id, 'quantity', Number(e.target.value))} style={{ width: '60px', padding: '4px' }} /></td>
                  <td><button className="devis-btn devis-btn-red" onClick={() => handleDeleteLine(line.id)}>Supprimer</button></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <button className="devis-btn devis-btn-blue" onClick={handlePublish} disabled={loading}>
          {loading ? 'Création...' : 'Créer le devis'}
        </button>
        <button className="devis-btn devis-btn-grey" onClick={() => navigate("/devis_list")}>
          Annuler
        </button>
      </div>
    </div>
  );
}